import clsx from 'clsx';
import { CSSProperties, ReactNode } from 'react';
import { BUTTON_SOURCES } from '@/constants/buttonSources';
import { useBrowserUserId } from '@/hooks/useBrowserUserId';
import { trackButtonClick } from '@/utils/gtmButtonClicked';

type ButtonSource = (typeof BUTTON_SOURCES)[keyof typeof BUTTON_SOURCES];

interface TrackedRedirectButtonProps {
  buttonId: string;
  buttonName: string;
  buttonSource: ButtonSource;
  style?: CSSProperties;
  className?: string;
  url: string;
  children?: ReactNode;
  isLoading?: boolean;
  instantRedirect?: boolean;
  'data-testid'?: string;
  urlParams: {
    brandId?: string;
    orderId?: string;
    tableNumber?: string;
    counterNumber?: string;
  };
}

const TrackedRedirectButton = ({
  buttonId,
  buttonName,
  buttonSource,
  style,
  className,
  url,
  urlParams,
  children,
  isLoading = false,
  instantRedirect = false,
  'data-testid': dataTestId,
}: TrackedRedirectButtonProps) => {
  const browserUserId = useBrowserUserId();
  const redirect = () => {
    return (window.location.href = url);
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();

    trackButtonClick({
      buttonId,
      buttonName,
      buttonSource,
      urlParams,
      onTracked: redirect,
      instantRedirect,
      extraParams: {
        browser_user_id: browserUserId,
      },
    });
  };

  return (
    <a
      id={buttonId}
      href={url}
      className={clsx(className)}
      data-testid={dataTestId}
      style={{
        cursor: 'pointer',
        ...style,
      }}
      onClick={handleClick}
      data-loading={isLoading}
    >
      {children || buttonName}
    </a>
  );
};

export default TrackedRedirectButton;
